import axios from 'axios';
import { URI_EVENT } from '../helpers/constans';
import {
  IAdminEventDetail,
  IAdminEventListItem,
  IEventGetResponseOk,
  IEventPutPayload,
  IEventPutResponseOk,
  TEventGetAllPayload,
} from '../types/@event';

export interface IAdminEventListResponse {
  data: IAdminEventListItem[];
  pages: number;
}

export const fetchEventGet = (page: TEventGetAllPayload): Promise<IEventGetResponseOk> => {
  return axios.get(`${URI_EVENT}?page=${page}`);
};

export const fetchEventPut = (payload: IEventPutPayload): Promise<IEventPutResponseOk> => {
  return axios.post(`${URI_EVENT}`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const fetchEventStatusConfig = (eventId: string) => {
  return axios.get(`${URI_EVENT}/${eventId}/status-config`);
};

export const fetchEventStatusPhrase = (
  eventId: string,
  payload: { context: string; refinement: string },
) => {
  return axios.post(`${URI_EVENT}/${eventId}/status-phrase`, payload);
};

export const fetchEventStatusApply = (
  eventId: string,
  payload: { ownerIds: string[]; text: string },
) => {
  return axios.post(`${URI_EVENT}/${eventId}/status-apply`, payload);
};

export const fetchEventStatusPlayers = (eventId: string) => {
  return axios.get(`${URI_EVENT}/${eventId}/status-players`);
};

export const fetchEventPosts = (eventId: string) => {
  return axios.get(`${URI_EVENT}/${eventId}/posts`);
};

export const fetchEventPatch = (eventId: string, payload: Record<string, any>) => {
  return axios.patch(`${URI_EVENT}/${eventId}`, payload);
};

export const fetchEventActivateItems = (eventId: string) => {
  return axios.post(`${URI_EVENT}/${eventId}/activate-items`, {});
};

export const fetchEventLockTeamKit = (eventId: string) => {
  return axios.post(`${URI_EVENT}/${eventId}/lock-team-kit`, {});
};

export const fetchAdminEvents = async (
  page: number | undefined = 1,
): Promise<IAdminEventListResponse> => {
  return axios.get(`${process.env.REACT_APP_URL}/admin/events?page=${page}`);
};

export const fetchAdminEventById = async (
  eventId: string,
): Promise<IAdminEventDetail> => {
  return axios.get(`${process.env.REACT_APP_URL}/admin/events/${eventId}`);
};

export const fetchAdminEventRiveUpload = async (
  eventId: string,
  payload: FormData,
): Promise<IAdminEventDetail> => {
  return axios.post(`${process.env.REACT_APP_URL}/admin/events/${eventId}/rive`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};